<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';

  .notices {
    z-index: 5000 !important;
  }

  body{
    overflow: hidden;
  }

  main{
    overflow-y: auto;
    height: calc(100vh - 50px)
  }
</style>

<template>
  <div>
    <Loader :size="90" v-if="!initialized" />
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'app',
    mounted(){
      this.$store.dispatch('setup');
    },
    computed: {
      ...mapState(['initialized'])
    }
  }
</script>
